import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { SPECIALISTS, DEFAULT_SPECIALIST, SPECIALIST_EVENT, specialistId } from "../lib/specialists";

const Portrait = ({ s, active }) => (
  <img
    src={s.face} alt={active ? `${s.name}, ${s.title}` : ""} aria-hidden={!active} draggable="false"
    className="absolute inset-0 h-full w-full transition-opacity duration-700 ease-out"
    style={{ objectFit: "cover", objectPosition: "center center", opacity: active ? 1 : 0 }}
  />
);

export default function SpeakerHeader({ caseId, onClose }) {
  const key = `gf.verdant.speaker.${caseId}`;
  const [id, setId] = useState(() => specialistId(sessionStorage.getItem(key)));

  useEffect(() => {
    const on = (e) => {
      const next = specialistId(e.detail?.id);
      sessionStorage.setItem(key, next);
      setId(next);
    };
    window.addEventListener(SPECIALIST_EVENT, on);
    return () => window.removeEventListener(SPECIALIST_EVENT, on);
  }, [key]);

  const s = SPECIALISTS[id] || SPECIALISTS[DEFAULT_SPECIALIST];
  return (
    <header data-testid="speaker-header" data-specialist={id} className="gf-gradient-dark text-white px-4 py-2 flex items-center gap-3">
      <div className="relative h-12 w-12 sm:h-14 sm:w-14 shrink-0 rounded-full overflow-hidden ring-2 ring-emerald-300/70 bg-emerald-900">
        {Object.entries(SPECIALISTS).map(([k, v]) => <Portrait key={k} s={v} active={k === id} />)}
      </div>
      <div className="flex-1 min-w-0" aria-live="polite">
        <div className="text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.18em] text-emerald-300">Now speaking</div>
        <div key={id} className="animate-in fade-in duration-700">
          <div data-testid="speaker-name" className="font-display font-bold leading-tight truncate">{s.name}</div>
          <div data-testid="speaker-title" className="text-[11px] sm:text-xs text-emerald-50/90 leading-snug truncate">{s.title}</div>
        </div>
        <div className="text-[10px] text-emerald-100/60 truncate">GreenFlow Plant Health &amp; Diagnostic Group</div>
      </div>
      <button data-testid="verdant-close" onClick={onClose} aria-label="Close Ask Dr. Verdant"
        className="h-10 w-10 shrink-0 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
        <X size={18} />
      </button>
    </header>
  );
}
